export type WebStateKind = "loading" | "empty" | "error" | "disabled";

export function StatePanel({ kind, title, message }: { readonly kind: WebStateKind; readonly title: string; readonly message: string }): JSX.Element {
  return <div className={`state ${kind}`} data-ui-state={kind}><b>{title}</b><span>{message}</span></div>;
}
